module.exports = __webpack_public_path__ + "img/chart.d762b9a0.svg";